.queriesTable {
  margin: 20px 0 20px 0;
}

.queriesTable :global(tr.ant-table-row) :global(td:empty:after) {
  content: '-';
}
